// localStorage 기반 "내 이미지" 저장소
const LS_KEY = 'orp_my_images';

const readAll = () => {
  try {
    const raw = localStorage.getItem(LS_KEY);
    if (!raw) return [];
    const list = JSON.parse(raw);
    return Array.isArray(list) ? list : [];
  } catch (e) {
    return [];
  }
};

const writeAll = (list) => {
  try {
    localStorage.setItem(LS_KEY, JSON.stringify(list));
  } catch (e) {}
};

export const getMyImages = () => readAll();

export const saveMyImage = (image) => {
  const list = readAll();
  const id = image.id || `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
  const entry = {
    id,
    name: image.name || '이미지',
    url: image.url,
    size: image.size || 0,
    width: image.width || 0,
    height: image.height || 0,
    source: image.source || 'bgRemover',
    createdAt: Date.now()
  };
  list.unshift(entry);
  writeAll(list);
  return entry;
};

export const removeMyImage = (id) => {
  const list = readAll().filter(it => it.id !== id);
  writeAll(list);
  return list;
};

export const renameMyImage = (id, newName) => {
  const list = readAll();
  const idx = list.findIndex(it => it.id === id);
  if (idx > -1) {
    list[idx].name = newName;
    writeAll(list);
  }
  return list;
};
